<script>
import urlLogoLightAvila from "@assets/images/logo-light.png";
import urlLogoLightAgeradora from "@assets/images/Ageradora/logo.png";
import urlLogoLightAvantia from "@assets/images/Avantia/logo.png";
import urlLogoLightFps from "@assets/images/Fps/logo.png";
import urlLogoSisloc from "@assets/images/Sisloc/LogoSisloc.png";
import urlLogoUnicap from "@assets/images/Unicap/logoUnicap.png";
import urlLogoASA from "@assets/images/Asa/logoASA.png";
export default {
  components: {},
  data() {
    return {
      logoLightAvila: urlLogoLightAvila,
      logoLightAgeradora: urlLogoLightAgeradora,
      logoLight: urlLogoLightAvila,
      logoLightAvantia: urlLogoLightAvantia,
      logoLightFps: urlLogoLightFps,
      logoSisloc: urlLogoSisloc,
      logoUnicap: urlLogoUnicap,
      logoASA: urlLogoASA,
      logoSM: "@assets/images/logo-sm.png",
      src: null
    };
  },
  mounted() {
    this.dynamicLog();
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    nome() {
      var nome = this.$store.state.auth.user.nome;
      if (nome.length > 20) {
        var nomes = nome.split(" ");
        nome = nomes[0];
      }
      return nome;
    }
    // corMenu(){
    //   if(this.user.clienteNome == "ASA"){
    //     console.log("entrou cor menu");
    //     return 'color: whitesmoke';
    //   }
    //   return '';
    // }
  },
  methods: {
    dynamicLog() {
      if (this.user.email.includes("ageradora")) {
        this.src = this.logoLightAgeradora;
      } else if (this.user.email.includes("avantia")) {
        this.src = this.logoLightAvantia;
      } else if (this.user.email.includes("fps")) {
        this.src = this.logoLightFps;
      } else if (
        this.user.email.includes("sisloc") ||
        this.user.clienteNome == "Sisloc"
      ) {
        this.src = this.logoSisloc;
      } else if (this.user.email.includes("unicap")) {
        this.src = this.logoUnicap;
      } else if (this.user.email.includes("asanet")) {
        this.src = this.logoASA;
      } else {
        this.src = this.logoLightAvila;
      }
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    }
  },
  created() {}
};
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar-custom">
    <div class="container-fluid">
      <ul class="list-unstyled topnav-menu float-right mb-0">
        <li class="dropdown notification-list">
          <a class="navbar-toggle nav-link" @click="toggleMenu">
            <div class="lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </a>
        </li>

        <b-nav-item-dropdown right class="notification-list">
          <template slot="button-content">
            <div class="nav-user mr-2 waves-effect waves-light">
              Olá, {{ this.nome }}!
            </div>
          </template>
          <b-dropdown-item href="/Logout">
            <i class="ri-logout-box-line mr-2"></i>
            <span>Sair</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </ul>

      <!-- LOGO -->

      <div class="row">
        <div class="logo-box mt-2 float-left">
          <a href="/" class="logo text-center">
            <span class="logo-lg">
              <img :src="src" class="logo" alt="" height="40" />
            </span>
            <span class="logo-sm">
              <img :src="src" class="logo-sm" alt="" height="35" />
            </span>
          </a>
        </div>
        <div class="float-left">
          <slot />
        </div>
      </div>
    </div>
  </div>

  <!-- end Topbar -->
</template>

<style lang="scss">
.notification-items {
  height: 220px;
}

.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}

.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}

@media (max-width: 767.98px) {
  .navbar-custom {
    height: 61px;
  }
  .logo,
  .logo-box,
  .navbar-toggle,
  .nav-link {
    height: 30px;
  }
  .navigation-menu {
    margin-top: 50px;
  }
  #navigation {
    top: 50px;
    height: 80vh;
  }
  .dropdown-menu {
    margin-top: 20px;
  }
  .nav-user {
    height: 45px;
  }
}
</style>
